import _slicedToArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function t(t, n, r) {
  return Math.min(Math.max(t, r), n);
}

var n = /*#__PURE__*/function (_Error) {
  _inherits(n, _Error);

  var _super = _createSuper(n);

  function n(t) {
    _classCallCheck(this, n);

    return _super.call(this, "Failed to parse color: \"".concat(t, "\""));
  }

  return n;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function r(r) {
  if ("string" != typeof r) throw new n(r);
  if ("transparent" === r.trim().toLowerCase()) return [0, 0, 0, 0];
  var e = r.trim();
  e = u.test(r) ? function (t) {
    var r = t.toLowerCase().trim(),
        e = o[function (t) {
      var n = 5381,
          r = t.length;

      for (; r;) {
        n = 33 * n ^ t.charCodeAt(--r);
      }

      return (n >>> 0) % 2341;
    }(r)];

    if (!e) throw new n(t);
    return "#".concat(e);
  }(r) : r;
  var f = s.exec(e);

  if (f) {
    var _t = Array.from(f).slice(1);

    return [].concat(_toConsumableArray(_t.slice(0, 3).map(function (t) {
      return parseInt(_(t, 2), 16);
    })), [parseInt(_(_t[3] || "f", 2), 16) / 255]);
  }

  var p = i.exec(e);

  if (p) {
    var _t2 = Array.from(p).slice(1);

    return [].concat(_toConsumableArray(_t2.slice(0, 3).map(function (t) {
      return parseInt(t, 16);
    })), [parseInt(_t2[3] || "ff", 16) / 255]);
  }

  var z = a.exec(e);

  if (z) {
    var _t3 = Array.from(z).slice(1);

    return [].concat(_toConsumableArray(_t3.slice(0, 3).map(function (t) {
      return parseInt(t, 10);
    })), [parseFloat(_t3[3] || "1")]);
  }

  var h = c.exec(e);

  if (h) {
    var _Array$from$slice$map = Array.from(h).slice(1).map(parseFloat),
        _Array$from$slice$map2 = _slicedToArray(_Array$from$slice$map, 4),
        _e = _Array$from$slice$map2[0],
        _o = _Array$from$slice$map2[1],
        _2 = _Array$from$slice$map2[2],
        _s = _Array$from$slice$map2[3];

    if (t(0, 100, _o) !== _o) throw new n(r);
    if (t(0, 100, _2) !== _2) throw new n(r);
    return [].concat(_toConsumableArray(l(_e, _o, _2)), [_s || 1]);
  }

  throw new n(r);
}

var e = function e(t) {
  return parseInt(t.replace(/_/g, ""), 36);
},
    o = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce(function (t, n) {
  var r = e(n.substring(0, 3)),
      o = e(n.substring(3)).toString(16);
  var _ = "";

  for (var _t4 = 0; _t4 < 6 - o.length; _t4++) {
    _ += "0";
  }

  return t[r] = "".concat(_).concat(o), t;
}, {}),
    _ = function _(t, n) {
  return Array.from(Array(n)).map(function () {
    return t;
  }).join("");
},
    s = new RegExp("^#".concat(_("([a-f0-9])", 3), "([a-f0-9])?$"), "i"),
    i = new RegExp("^#".concat(_("([a-f0-9]{2})", 3), "([a-f0-9]{2})?$"), "i"),
    a = new RegExp("^rgba?\\(\\s*(\\d+)\\s*".concat(_(",\\s*(\\d+)\\s*", 2), "(?:,\\s*([\\d.]+))?\\s*\\)$"), "i"),
    c = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i,
    u = /^[a-z]+$/i,
    f = function f(t) {
  return Math.round(255 * t);
},
    l = function l(t, n, r) {
  var e = r / 100;
  if (0 === n) return [e, e, e].map(f);

  var o = (t % 360 + 360) % 360 / 60,
      _ = (1 - Math.abs(2 * e - 1)) * (n / 100),
      s = _ * (1 - Math.abs(o % 2 - 1));

  var i = 0,
      a = 0,
      c = 0;
  o >= 0 && o < 1 ? (i = _, a = s) : o >= 1 && o < 2 ? (i = s, a = _) : o >= 2 && o < 3 ? (a = _, c = s) : o >= 3 && o < 4 ? (a = s, c = _) : o >= 4 && o < 5 ? (i = s, c = _) : o >= 5 && o < 6 && (i = _, c = s);
  var u = e - _ / 2;
  return [i + u, a + u, c + u].map(f);
};

function p(t) {
  var _r$map = r(t).map(function (t, n) {
    return 3 === n ? t : t / 255;
  }),
      _r$map2 = _slicedToArray(_r$map, 4),
      n = _r$map2[0],
      e = _r$map2[1],
      o = _r$map2[2],
      _ = _r$map2[3],
      s = Math.max(n, e, o),
      i = Math.min(n, e, o),
      a = (s + i) / 2;

  if (s === i) return [0, 0, a, _];
  var c = s - i;
  return [60 * (n === s ? (e - o) / c + (e < o ? 6 : 0) : e === s ? (o - n) / c + 2 : (n - e) / c + 4), a > .5 ? c / (2 - s - i) : c / (s + i), a, _];
}

function z(n, r, e, o) {
  return "hsla(".concat((n % 360).toFixed(), ", ").concat(t(0, 100, 100 * r).toFixed(), "%, ").concat(t(0, 100, 100 * e).toFixed(), "%, ").concat(parseFloat(t(0, 1, o).toFixed(3)), ")");
}

function h(t, n) {
  var _p = p(t),
      _p2 = _slicedToArray(_p, 4),
      r = _p2[0],
      e = _p2[1],
      o = _p2[2],
      _ = _p2[3];

  return z(r + n, e, o, _);
}

function d(t, n) {
  var _p3 = p(t),
      _p4 = _slicedToArray(_p3, 4),
      r = _p4[0],
      e = _p4[1],
      o = _p4[2],
      _ = _p4[3];

  return z(r, e, o - n, _);
}

function g(t, n) {
  var _p5 = p(t),
      _p6 = _slicedToArray(_p5, 4),
      r = _p6[0],
      e = _p6[1],
      o = _p6[2],
      _ = _p6[3];

  return z(r, e - n, o, _);
}

function w(t) {
  if ("transparent" === t) return 0;

  function n(t) {
    var n = t / 255;
    return n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
  }

  var _r = r(t),
      _r2 = _slicedToArray(_r, 3),
      e = _r2[0],
      o = _r2[1],
      _ = _r2[2];

  return .2126 * n(e) + .7152 * n(o) + .0722 * n(_);
}

function x(t, n) {
  var r = w(t),
      e = w(n);
  return r > e ? (r + .05) / (e + .05) : (e + .05) / (r + .05);
}

function m(n, r, e, o) {
  return "rgba(".concat(t(0, 255, n).toFixed(), ", ").concat(t(0, 255, r).toFixed(), ", ").concat(t(0, 255, e).toFixed(), ", ").concat(parseFloat(t(0, 1, o).toFixed(3)), ")");
}

function y(t, n, e) {
  var o = function o(t, n) {
    return 3 === n ? t : t / 255;
  },
      _r$map3 = r(t).map(o),
      _r$map4 = _slicedToArray(_r$map3, 4),
      _ = _r$map4[0],
      s = _r$map4[1],
      i = _r$map4[2],
      a = _r$map4[3],
      _r$map5 = r(n).map(o),
      _r$map6 = _slicedToArray(_r$map5, 4),
      c = _r$map6[0],
      u = _r$map6[1],
      f = _r$map6[2],
      l = _r$map6[3],
      p = l - a,
      z = 2 * e - 1,
      h = ((z * p == -1 ? z : z + p) / (1 + z * p) + 1) / 2,
      d = 1 - h;

  return m(255 * (_ * d + c * h), 255 * (s * d + u * h), 255 * (i * d + f * h), l * e + a * (1 - e));
}

function b() {
  var n = [].slice.call(arguments);
  return function (r) {
    var e = n.length - 1,
        o = t(0, e, Math.floor(r * e)),
        _ = t(0, e, Math.ceil(r * e)),
        s = 1 / e;

    return y(n[o], n[_], (r - s * o) / s);
  };
}

var k = {
  decorative: 1.5,
  readable: 3,
  aa: 4.5,
  aaa: 7
};

function j(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "aa";
  return x(t, "#fff") < k[n];
}

function $(t, n) {
  return d(t, -n);
}

function v(t, n) {
  var _r3 = r(t),
      _r4 = _slicedToArray(_r3, 4),
      e = _r4[0],
      o = _r4[1],
      _ = _r4[2],
      s = _r4[3];

  return m(e, o, _, s - n);
}

function q(t, n) {
  return v(t, -n);
}

function F(t) {
  return w(t) > .179;
}

function M(t) {
  return F(t) ? "#000" : "#fff";
}

function A(t, n) {
  return g(t, -n);
}

function I(n) {
  var _r5 = r(n),
      _r6 = _slicedToArray(_r5, 4),
      e = _r6[0],
      o = _r6[1],
      _ = _r6[2],
      s = _r6[3];

  var i = function i(n) {
    var r = t(0, 255, n).toString(16);
    return 1 === r.length ? "0".concat(r) : r;
  };

  return "#".concat(i(e)).concat(i(o)).concat(i(_)).concat(s < 1 ? i(Math.round(255 * s)) : "");
}

function E(t) {
  return m.apply(void 0, _toConsumableArray(r(t)));
}

function C(t) {
  return z.apply(void 0, _toConsumableArray(p(t)));
}

export { n as ColorError, h as adjustHue, d as darken, g as desaturate, x as getContrast, w as getLuminance, b as getScale, t as guard, j as hasBadContrast, z as hsla, $ as lighten, y as mix, q as opacify, p as parseToHsla, r as parseToRgba, M as readableColor, F as readableColorIsBlack, m as rgba, A as saturate, I as toHex, C as toHsla, E as toRgba, v as transparentize };